module.exports = __webpack_public_path__ + "static/media/tennis-ball.684aa95d.png";